import { FaPlus } from "react-icons/fa";
import Tooltip from "../ToolTip";

const DinamicBoxButton = ({ action = null, content, disabled = false, icon = <FaPlus className="text-[10px]"/>, color = "blue", padding = "1.5" }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action ? action() : null}
        disabled={disabled}
        className={`p-${padding} text-${color}-500 ${disabled ? 'opacity-50' : 'hover:bg-opacity-25'} ${disabled ? '' : 'hover:cursor-pointer'} rounded-md bg-${color}-700 bg-opacity-10 flex transition-all duration-100 items-center`}
      >
        {icon}
      </button>
    </Tooltip>
  )
}

export default DinamicBoxButton;
